"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var helpers_1 = require("../abstracts/helpers");
var ganttlab_entities_1 = require("ganttlab-entities");
var parse_link_header_1 = __importDefault(require("parse-link-header"));
function getTaskFromGitHubIssue(githubIssue) {
    var _a = helpers_1.issueDescriptionToTaskDetails(githubIssue.body), startDate = _a.startDate, dueDate = _a.dueDate;
    return new ganttlab_entities_1.Task(githubIssue.title, githubIssue.html_url, startDate ? startDate : new Date(githubIssue.created_at), dueDate ? dueDate : undefined);
}
exports.getTaskFromGitHubIssue = getTaskFromGitHubIssue;
function getPaginationFromGitHubHeaders(headers) {
    var linkHeader = parse_link_header_1.default(headers['link']);
    return {
        previousPage: linkHeader && linkHeader.prev && linkHeader.prev.page
            ? parseInt(linkHeader.prev.page)
            : undefined,
        nextPage: linkHeader && linkHeader.next && linkHeader.next.page
            ? parseInt(linkHeader.next.page)
            : undefined,
        lastPage: linkHeader && linkHeader.last && linkHeader.last.page
            ? parseInt(linkHeader.last.page)
            : undefined,
        total: undefined,
    };
}
exports.getPaginationFromGitHubHeaders = getPaginationFromGitHubHeaders;
function getMilestoneFromGitHubMilestone(githubMilestone) {
    return new ganttlab_entities_1.Milestone(githubMilestone.title, githubMilestone.html_url, githubMilestone.description, undefined, githubMilestone.due_on ? new Date(githubMilestone.due_on) : undefined);
}
exports.getMilestoneFromGitHubMilestone = getMilestoneFromGitHubMilestone;
//# sourceMappingURL=helpers.js.map